import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  templateUrl: './pagination.html',
  selector: 'pagination'
})

export class PaginationComponent implements OnInit {
  @Input() public boundaryLinks = false;
  @Input() public set page(value: number) {
    if (this._page !== value) {
      this._page = value;
      this.makePages();
    }
  }
  @Input() public set total(value: number) {
    if (this._total !== value) {
      this._total = value;
      this.makePages();
    }
  }
  @Input() public set limit(value: number) {
    if (this._limit !== value) {
      this._limit = value;
      this.makePages();
    }
  }
  @Input() public set previousText(value: string) {
    if (value || value === null) {
      this._previousText = value;
    }
  }
  @Input() public set nextText(value: string) {
    if (value || value === null) {
      this._nextText = value;
    }
  }
  @Output() public change: EventEmitter<any> = new EventEmitter<any>();
  public get page() {
    return this._page;
  }

  public _totalPages: number[] = [];
  public _nextText = 'Next';
  public _previousText = 'Prev';
  public _total: number;
  public _page: number;
  public _limit: number;
  public nextPage: number;
  public prevPage: number;

  private createArr(min: number, max: number): number[] {
    const arr = [];

    for (let i = min; i < min + max; i = i + 1) {
      arr.push(i);
    }

    return arr;
  }

  private makePagination(): number[] {
    const magicNumber = Math.ceil(this._limit / 2);
    const length = this._total < this._limit ? this._total : this._limit;

    if (this.page < magicNumber) {
      return this.createArr(1, length);
    } else if (this.page > this._total - magicNumber) {
      return this.createArr(this._total - length + 1, length);
    } else if (this.page >= magicNumber && this.page <= this._total - magicNumber) {
      return this.createArr(this.page - Math.floor(length / 2), length);
    }
  }

  private makePages(): void {
    if (!this._limit || !this.page || !this._total) {
      return;
    }

    this._totalPages = this.makePagination();
    this.nextPage = this.page + 1 > this._totalPages[this._totalPages.length - 1] ? this.page : this.page + 1;
    this.prevPage = this.page - 1 < 1 ? this.page : this.page - 1;
  }

  public onChange(page: number, $event): void {
    this.page = page;
    this.change.emit(this.page);
  }

  public ngOnInit() {
    this.makePages();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/pagination.component.ts